import { Modal } from "antd";
import { firebaseStorage } from "config";

export const deleteCurrentFile = async (path) => {
  const res = await firebaseStorage.child(path).delete();
  return res;
};

export const uploadFileBase64 = (file, path, onFileReady, progress) => {
  const imagesFilesRef = firebaseStorage.child(path);
  // console.log('uploading image');
  const task = imagesFilesRef.putString(file, "data_url", {
    contentType: "image/jpg",
  });

  task.on("state_changed", (snapshot) => {
    const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    progress(percentage);
  });

  task.then(() =>
    imagesFilesRef.getDownloadURL().then((urlSnap) => onFileReady(urlSnap))
  );

  return task;
};

export const uploadFile = (file, path, onFileReady, progress, errors) => {
  const itemRef = firebaseStorage.child(path);
  const uploadTask = itemRef.put(file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const currentProgress =
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      progress(currentProgress);
      // console.log(`Upload is ${currentProgress}% done`);
    },
    (error) => {
      console.error(error);
      const props = { title: "Error", content: "" };
      switch (error.code) {
        case "storage/unauthorized":
          props.content = "El usuario no tiene permiso para acceder al objeto";
          break;
        case "storage/canceled":
          props.content = "El usuario canceló la carga";
          break;
        case "storage/unknown":
          props.content = "Se produjo un error desconocido";
          break;
        default:
          props.content = "Error";
          break;
      }
      errors(props);
      // Modal.error({ ...props });
    },
    () => itemRef.getDownloadURL().then((urlSnap) => onFileReady(urlSnap))
  );
};
